import { ApiGWCaller } from "@warda/library-ui/contexts/ApiGWCaller";
import { BASE_URL } from "../../constants/keys";
import authCookiesHelper from "../../constants/authCookiesHelper";
export const doAuthenticatedCall = async ({ url, method, data, retries, retryDelay, }) => {
    const res = await ApiGWCaller({
        baseUrl: BASE_URL,
        retries,
        retryDelay,
    }).doCall({
        url,
        method,
        data,
        withCredentials: true,
        authorization: authCookiesHelper.getAuthorization(),
    });
    return res;
};
